import { AUTO_TEST_URL } from '../constants';
import { EnvironmentUrlsConfig } from '../environment-urls-config.interface';

const getValidEnvironment = (origin: string, isMs: boolean, allowedMsEnvs: string[]) => {
  const env = origin
    .split('://')[1]
    .split('.')[0]
    .replace(/-checkout|-pos|-my|-support|-smartwatch/i, '');
  if (!isMs || allowedMsEnvs.includes(env)) return env;
  return undefined;
};
const calcPrismicRepo = (env: string, brand: string) => {
  const isLocalOrDev = env === 'test' || env.startsWith('localhost');
  return `sunrise-${brand}${isLocalOrDev ? '-test' : ''}`;
};
export const calcEnvironmentUrls = (
  environment: {
    newMicroServiceEndpoint?: string;
    websiteUrl?: string;
    checkoutUrl?: string;
    posUrl?: string;
    selfcareUrl?: string;
    roamingCockpitUrl?: string;
    defaultUrlsEnvironment: string;
    allowedMsEnvs: string[];
    yalloTvUrl?: string;
    brand: string;
    threatMetrixConfig?: {
      url: string;
      orgId: string;
    };
  },
  origin: string
): EnvironmentUrlsConfig => {
  const brand = environment.brand;
  const msEnv = getValidEnvironment(origin, true, environment.allowedMsEnvs) || environment.defaultUrlsEnvironment;
  const env = getValidEnvironment(origin, false, environment.allowedMsEnvs) || environment.defaultUrlsEnvironment;
  const prismicRepo = calcPrismicRepo(env, brand);

  return {
    devEnv: msEnv && msEnv !== '' ? msEnv : undefined,
    newMicroServiceEndpoint:
      environment.newMicroServiceEndpoint === AUTO_TEST_URL
        ? `https://${msEnv}.staging.ms.api.${brand}.ch`
        : environment.newMicroServiceEndpoint,
    websiteUrl: environment.websiteUrl !== AUTO_TEST_URL ? environment.websiteUrl : `https://${env}.dev.${brand}.ch`,
    checkoutUrl:
      environment.checkoutUrl !== AUTO_TEST_URL ? environment.checkoutUrl : `https://${env}-checkout.dev.${brand}.ch`,
    posUrl: environment.posUrl !== AUTO_TEST_URL ? environment.posUrl : `https://${env}-pos.dev.${brand}.ch`,
    selfcareUrl:
      environment.selfcareUrl !== AUTO_TEST_URL ? environment.selfcareUrl : `https://${env}-my.dev.${brand}.ch`,
    roamingCockpitUrl:
      environment.roamingCockpitUrl !== AUTO_TEST_URL
        ? environment.roamingCockpitUrl
        : `https://${env}-cockpit.dev.${brand}.ch`,
    yalloTvUrl: environment.yalloTvUrl,
    prismicRepo,
    threatMetrixConfig: environment.threatMetrixConfig,
  };
};
